// extracted by mini-css-extract-plugin
export default {"activityBanner":"index_activityBanner_hC-lC","activityBannerImg":"index_activityBannerImg_BxXfp"};